var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"x":"15","width":"5","height":"19"}}),_c('rect',{attrs:{"x":"4","width":"5","height":"19"}}),_c('rect',{attrs:{"x":"11","width":"2","height":"19"}}),_c('rect',{attrs:{"width":"2","height":"24"}}),_c('rect',{attrs:{"x":"22","width":"2","height":"24"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }